/**
 * Tab counts on the work item and client pages (Roadmap 1842).
 * A count is only shown once it is known; while it loads (or when it can't be
 * loaded) the tab shows just its name instead of a wrong "0".
 */
export type TabCount = number | string | undefined;

export const tabLabel = (label: string, count: TabCount) =>
  count === undefined || count === "" ? label : `${label} ${count}`;

/** Length of a loaded list; "N+" when the server returned only the first N. */
export const listCount = (
  list: unknown[] | undefined | null,
  options: { more?: boolean; cap?: number } = {},
): TabCount => {
  if (!Array.isArray(list)) return undefined;
  const more =
    options.more || (options.cap !== undefined && list.length >= options.cap);
  return more ? `${list.length}+` : list.length;
};

/** The address the client's Email tab looks up (primary, else the first). */
export const primaryEmailOf = (
  client?: {
    emails?: { emailAddress?: string | null; isPrimaryEmail?: boolean }[];
  } | null,
) => {
  const emails = client?.emails || [];
  const primary = emails.find((email) => email.isPrimaryEmail);
  return primary?.emailAddress || emails[0]?.emailAddress || "";
};
